(ns rothko.dom.url
  (:require #?(:cljs [cemerick.url :as url])
            [clojure.edn :as edn]))

(defn query-params->edn
  [query-params]
  (into {}
        (map (fn [[k v]]
               [(keyword k) (edn/read-string v)]))
        query-params))

#?(:cljs
   (defn current-url
     []
     (-> js/window .-location .-href url/url)))

#?(:cljs
   (defn merge-params-into-query-string
     [new-params]
     (let [url (str (update (current-url) :query
                            (fn [query]
                              (url/map->query
                               (merge (query-params->edn query)
                                      new-params)))))
           state (or (.-state js/history) #js {})]
       (.pushState js/history state nil url))))

#?(:cljs
   (defn extract-params-from-query-string
     []
     (-> (current-url) :query query-params->edn)))
